import 'rxjs/add/operator/toPromise';

import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpHeaderResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { DisabledKeys, ServerErrors } from '../dictionaries';
import { Configuration, MailMessage, RequestOptions, ServerResponse, UserImage, UserRequest, ServerResult } from '../models';
import { AppConfig } from './app.config';
import {Router} from '@angular/router';

@Injectable()
export class RestService {
    private Config: Configuration;
    private sessionExceptionSubject = new BehaviorSubject<ServerResponse<any>>(null);
    private stateBlockUIByLoading = new BehaviorSubject<boolean>(null);
    private requestExceptionSubject = new BehaviorSubject<ServerResponse<any>>(null);
    public showPopUp: boolean;
    public showPopupTariffRestriction: boolean;
    public isAllowGoFromSettings: boolean;
    public isShowPopupSaveSettigs: boolean;
    public nextRoute: string | null;
    public showPopupTariffRestriction_message: string;

    constructor(
      private http: HttpClient,
      private router: Router
    ) {
        this.Config = AppConfig.config;
        this.showPopUp = false;
        this.showPopupTariffRestriction = false;
        this.isAllowGoFromSettings = true;
        this.isShowPopupSaveSettigs = false;
        this.nextRoute = null;
    }

    public cancelGoFromSettings() {
      if (this.isAllowGoFromSettings) this.isAllowGoFromSettings = false;
    }

    public confirm(url: string) {
      this.isShowPopupSaveSettigs = true;
      this.nextRoute = url;
    }

    public closePopupSaveSettings() {
      this.isShowPopupSaveSettigs = false;
      this.isAllowGoFromSettings = true;
      if (this.nextRoute && this.isAllowGoFromSettings) {
        this.router.navigateByUrl(this.nextRoute);
      }
    }

    public getSessionExceptionSub(): Observable<ServerResponse<any>> {
        return this.sessionExceptionSubject.asObservable();
    }

    public initBlockStateByLoading() {
        this.stateBlockUIByLoading.next(true);
    }

    public disableBlockStateByLoading() {
        this.stateBlockUIByLoading.next(false);
    }

    public getStateBlockUIByLoading(): Observable<boolean> {
        return this.stateBlockUIByLoading.asObservable();
    }

    public getRequestExceptionSub(): Observable<ServerResponse<any>> {
        return this.requestExceptionSubject.asObservable();
    }

    private throwException(serverResponse: ServerResponse<any> | HttpErrorResponse) {
        if (serverResponse instanceof HttpErrorResponse) {
            const message = serverResponse.error.Message || serverResponse.message;
            serverResponse = new ServerResponse<any>();
            serverResponse.Result = new ServerResult<any>();
            serverResponse.Result.ReturnCode = -6;
            serverResponse.Result.Message = message;
        }

        switch (serverResponse.Result.ReturnCode) {
            case ServerErrors.SessionNotFound:
                this.sessionExceptionSubject.next(serverResponse);
                break;
            default:
                this.requestExceptionSubject.next(serverResponse);
                break;
        }
    }

    public getImageInfo<T>(url: string, options: object) {
        return this.checkImageExists(url, options);
    }

    private checkImageExists(url: string, options?: object) {
        return new Promise<any>((resolve, reject) => {
            const subscription = this.http.head(url, {observe: 'response', responseType: 'blob' });
            this.checkResponseTypeForImage(subscription).then(response => {
                resolve(response);
            },
            error => {
                reject(error);
            });
        });
    }

    private checkResponseTypeForImage(subscription: Observable<any>) {
        return new Promise<any>((resolve, reject) => {
            subscription.subscribe((response: any) => {
                if (response.body.type.indexOf('image') === -1 || response.headers.get('Content-Length') > 111000) {
                     reject(null);
                }
                resolve(response);
            }, (error: HttpErrorResponse) => {
                reject(error);
            });
        });
    }

    private handleSubscription(subscription: Observable<any>, redirect?: boolean, withoutThrowException?: boolean) {
        return new Promise<ServerResponse<any>>((resolve, reject) => {
            subscription.subscribe((response: ServerResponse<any>) => {
                if (response) {
                    if (response.Result && response.Result.ReturnCode < 0) {
                        if (response.Result.ReturnCode === ServerErrors.TariffRestriction) {
                            this.showPopupTariffRestriction = true;
                            this.showPopupTariffRestriction_message = response.Result.Message;
                        }
                        if (!withoutThrowException) {
                          this.throwException(response);
                        }
                    }
                    resolve(response);
                }
            }, (error: HttpErrorResponse) => {
              this.disableBlockStateByLoading();
              (redirect) ? this.router.navigate([`/main/not-found`]) : this.showPopUp = true;
              if (!withoutThrowException) {
                this.throwException(error);
              }
              reject(error);
            });
        });
    }

    public closePopupTarif() {
      this.showPopupTariffRestriction = false;
    }

    private handledGet(url: string, options?: object, redirect?: boolean) {
        this.initBlockStateByLoading();
        return new Promise<ServerResponse<any>>((resolve, reject) => {
            const subscription = this.http.get(url, options);
            this.handleSubscription(subscription, redirect).then(response => {
                this.disableBlockStateByLoading();
                resolve(response);
            },
                error => {
                     this.disableBlockStateByLoading();
                    reject(error);
                });
        });
    }

  private handledPost(url: string, body?: object, options?: object, withoutThrowException?: boolean, withoutStateLoading?: boolean) {
    if (!withoutStateLoading) {
      this.initBlockStateByLoading();
    }
    return new Promise<ServerResponse<any>>((resolve, reject) => {
      const subscription = this.http.post(url, body, options);
      this.handleSubscription(subscription, false, withoutThrowException).then(response => {
        if (!withoutStateLoading) {
          this.disableBlockStateByLoading();
        }
        resolve(response);
        if (!withoutStateLoading) {
          setTimeout(() => {
            this.disableBlockStateByLoading();
          }, 100);
        }
      }, error => {
        if (!withoutStateLoading) {
          this.disableBlockStateByLoading();
        }
        reject(error);
      });
    });
  }

    public get(data: RequestOptions): Promise<ServerResponse<any>> {
        return this.handledGet(this.formUrlString(data) + this.getQuery(data));
    }

  // withoutThrowException для каскада запросов, чтобы не выводит ошибки на каждый запрос
  // withoutStateLoading для реализации спинера при каскадном запросе
  public post(data: RequestOptions, withoutThrowException?: boolean, withoutStateLoading?: boolean): Promise<ServerResponse<any>> {
    data.signature = AppConfig.config.HashSalt;
    return this.handledPost(this.formUrlString(data), this.cutSystems(data), undefined, withoutThrowException, withoutStateLoading);
  }

    public getSocialUserInfoPromise(code: string, methodName: string, codeParameterName: string): Promise<any> {
        const request = new RequestOptions();
        request.Id_app = 3;
        request.Controller0 = 'Account';
        request.Method = methodName;
        request.ApiVersion = 'v2';
        request.ManualJSON = 0;
        return this.handledGet(`${this.formUrlString(request)}?${codeParameterName}=${code}`);
    }

    public registerUser(userInfo: UserRequest): Promise<any> {
        this.initBlockStateByLoading();
        userInfo.signature = AppConfig.config.HashSalt;
        userInfo.Id_app = this.Config.AppId;

        return this.handledPost(`${this.Config.ServerUrl + this.Config.ApiService}/v2/Account/RegisterUser`, userInfo);
    }

    public logInUser(userInfo: UserRequest): Promise<any> {
        return this.handledPost(`${this.Config.ServerUrl + this.Config.ApiService}/v2/Account/LogIn`, userInfo);
    }

    public uploadFile(
        relativeUrl: string, image: UserImage, type: string): Promise<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Upload-Content-Type': type
            })
        };

        return this.handledPost(
            this.Config.ServerUrl + this.Config.ApiService + relativeUrl, image, httpOptions);
    }

    public sendEmail(message: MailMessage) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        };

        return this.handledPost(this.Config.ServerUrl + this.Config.ApiService + '/v2/Email/SendMessage',
            message,
            httpOptions);
    }

    public confirmEmail(key: string) {
        return this.handledPost(this.Config.ServerUrl + this.Config.ApiService + '/v2/Account/Confirm', { key: key });
    }

    private formUrlString(requestDictionary: any) {
        let sectionBlock = '';
        if (requestDictionary['Section']) {
            sectionBlock = requestDictionary['Section'] + '/';
        }

        let controllerEntityBlock = '';
        for (let i = 0; i < 3; i++) {
            const keyName = `Controller${i}`;
            if (requestDictionary[keyName]) {
                const controllerName = requestDictionary[keyName];
                const valueName = `EntityId${i}`;
                controllerEntityBlock += `${controllerName}/`;

                if (requestDictionary[valueName] !== undefined) {
                    const entityValue = requestDictionary[valueName];
                    controllerEntityBlock += `${entityValue}/`;
                }
            }
        }
        const urlString =
            `${this.Config.ServerUrl + this.Config.ApiService}` +
            `/${requestDictionary.ApiVersion}/${controllerEntityBlock}${sectionBlock}${requestDictionary.Method}`;

        return urlString;
    }

    private getQuery(requestDictionary: any) {
        requestDictionary.signature = AppConfig.config.HashSalt;
        const disabledKeysDict = new DisabledKeys();
        const hashkeys: string[] = [];

        Object.keys(requestDictionary).filter(key => requestDictionary[key] !== undefined).forEach(key => {
            let flag = false;
            disabledKeysDict.Keys.forEach(x => {
                if (!flag) {
                    flag = key.toLowerCase() === x.toLowerCase();
                }
            });
            if (!flag) {
                hashkeys.push(`${key.toLowerCase()}=${encodeURIComponent(requestDictionary[key])}`);
            }
        });

        const queryString = `?${hashkeys.sort((a, b) => (a > b ? 1 : -1)).join('&')}`;
        return queryString;
    }

    private cutSystems(requestDictionary: RequestOptions): RequestOptions {
        requestDictionary.Controller0 = undefined;
        requestDictionary.Controller1 = undefined;
        requestDictionary.Controller2 = undefined;
        requestDictionary.Controller3 = undefined;
        requestDictionary.EntityId0 = undefined;
        requestDictionary.EntityId1 = undefined;
        requestDictionary.EntityId2 = undefined;
        requestDictionary.EntityId3 = undefined;
        requestDictionary.Method = undefined;
        requestDictionary.Section = undefined;
        requestDictionary.ApiVersion = undefined;
        return requestDictionary;
    }

    public checkUserStatus(cred) {
        return this.handledPost(
            `${this.Config.ServerUrl + this.Config.ApiService}/v2/Account/CheckUserStatus?session=${cred.Id_Session}&name=${cred.Region}`, undefined);
    }

    public changeEmail(id: number, email: string, password: string) {
        const changeObject = {
            'UserId': id,
            'Email': email,
            'Password': password
        };
        return this.handledPost(`${this.Config.ServerUrl + this.Config.ApiService}/v2/Account/ChangeEmail`, changeObject);
    }

    public changeRegion(id_user: number, id_session: string, region: string) {
        const changeObject = {
            'id_app': this.Config.AppId,
            'id_session': id_session,
            'Region': region,
            'signature': this.Config.HashSalt
        };
        return this.handledPost(`${this.Config.ServerUrl + this.Config.ApiService}/v1/User/${id_user}/update`, changeObject);
    }

    public confirmEmailChange(key: string, session: string) {
        return this.handledPost(this.Config.ServerUrl + this.Config.ApiService + '/v2/Account/ConfirmMailChange',
            { Key: key, Session: session });
    }

    public urlGet<T>(url: string, options: object, redirect?: boolean) {
        return this.handledGet(url, options , redirect);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/rest.service.ts